"use client"
import { Form, TextHeading } from "@opensea/ui-kit"
import { useForm } from "react-hook-form"
import { useTranslations } from "use-intl"
import { AuthCode } from "../../../components/AuthCode"

type FormData = {
  code: string
}

type Props = {
  onSubmit: (data: FormData) => void
}

export function CodeInputStep({ onSubmit }: Props) {
  const t = useTranslations("wallet.CodeInputStep")
  const { register, handleSubmit, setValue } = useForm<FormData>({
    defaultValues: {
      code: "",
    },
    mode: "onBlur",
  })
  return (
    <Form onSubmit={handleSubmit(onSubmit)}>
      <TextHeading asChild className="mb-6 block" size="md">
        <label htmlFor="connect-embedded-wallet-code-input">
          {t("enterCode")}
        </label>
      </TextHeading>
      <AuthCode
        id="connect-embedded-wallet-code-input"
        {...register("code", {
          required: true,
          minLength: 6,
          maxLength: 6,
        })}
        onChange={value => setValue("code", value)}
        onComplete={() => handleSubmit(onSubmit)()}
      />
    </Form>
  )
}
